import PropTypes from 'prop-types'
import AuthService from "../../services/auth-service";
import React, {FunctionComponent, PropsWithChildren} from "react";


type RenderOnRoleProperties = PropsWithChildren<{
    roles: string[];
}>;

const RenderOnRole: FunctionComponent<RenderOnRoleProperties>
    = ({roles, children}) => AuthService.hasRole(roles)
    ? <>{children}</>
    : null;

RenderOnRole.propTypes = {
    roles: PropTypes.array.isRequired,
}

export default RenderOnRole